import React from "react";
import GoogleMapReact from "google-map-react";

import GoogleMapWrapper from "../misc/GoogleMapWrapper";
import LocationMarker from "../misc/LocationMarker";

const handleApiLoaded = (map, maps) => {
    // console.log("map");
    // console.log(map);
    // console.log("maps");
    // console.log(maps);
};

const IndexMap = ({
    locations,
    jumpToLocation,
    geographicCenter = {
        //Brownwood, Texas
        lat: 31.7093,
        lng: -98.9912
    }
}) => (
    <GoogleMapWrapper>
        <GoogleMapReact
            bootstrapURLKeys={{
                key: "AIzaSyBlIqDi-Hz4z37d7J7RM65S0_35X5tbbEE"
            }}
            defaultCenter={geographicCenter}
            defaultZoom={4.7}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
            onChildClick={(key, childProps) =>
                jumpToLocation(childProps.location)
            }
        >
            {locations &&
                locations.map(location => (
                    <LocationMarker
                        key={location.locationId}
                        lat={location.latitude}
                        lng={location.longitude}
                        location={location}
                    />
                ))}
        </GoogleMapReact>
    </GoogleMapWrapper>
);

export default IndexMap;



// WEBPACK FOOTER //
// ./components/index/IndexMap.jsx